import { __decorate, __extends } from "tslib";
import { injectable } from 'tsyringe';
import { BasketPlugin } from '../../models';
var BasketItemExceptionHandlerPlugin = /** @class */ (function (_super) {
    __extends(BasketItemExceptionHandlerPlugin, _super);
    function BasketItemExceptionHandlerPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleError = function (exception) {
            if (!exception) {
                return;
            }
            switch (exception.type) {
                case "InvalidProductItemException" /* BasketExceptionType.InvalidProductItemException */:
                case "HookStatusException" /* BasketExceptionType.HookStatusException */:
                    if (exception.arguments.statusMessage === "ENGRAVING_VALIDATION_ERROR" /* BasketError.EngravingValidation */) {
                        var errorMessage = { text: _this.translations.EngravingMessageInValid };
                        _this.eventBus.post("push-message" /* BasketEvent.PushMessage */, errorMessage);
                        break;
                    }
                case "ProductItemNotAvailableException" /* BasketExceptionType.ProductItemNotAvailableException */:
                    // When product id is either invalid or quantity is not available.
                    var message = { text: _this.translations.ExceptionProductCannotBeAdded };
                    _this.eventBus.post("push-message" /* BasketEvent.PushMessage */, message);
                    break;
                case "ProductItemNotFoundException" /* BasketExceptionType.ProductItemNotFoundException */:
                    /** Might occur if user removed product item from tab and tries to remove it from another one  */
                    _this.eventBus.post("push-message" /* BasketEvent.PushMessage */, {});
                    break;
                case "PropertyConstraintViolationException" /* BasketExceptionType.PropertyConstraintViolationException */:
                    // The error occurred when quantity of the product is set to 1000+.
                    if (exception.message.indexOf('$.quantity') > -1) {
                        _this.eventBus.post("push-message" /* BasketEvent.PushMessage */, {});
                    }
                    break;
                default:
                    break;
            }
        };
        return _this;
    }
    BasketItemExceptionHandlerPlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus, translations = _a.translations;
        this.eventBus = eventBus;
        this.translations = translations;
        this.eventBus.subscribe("error-occurred" /* BasketEvent.ErrorOccurred */, this.handleError);
    };
    BasketItemExceptionHandlerPlugin.prototype.shouldRegister = function () {
        return true;
    };
    BasketItemExceptionHandlerPlugin.prototype.unregister = function () {
        this.eventBus.unsubscribe("error-occurred" /* BasketEvent.ErrorOccurred */, this.handleError);
    };
    BasketItemExceptionHandlerPlugin = __decorate([
        injectable()
    ], BasketItemExceptionHandlerPlugin);
    return BasketItemExceptionHandlerPlugin;
}(BasketPlugin));
export { BasketItemExceptionHandlerPlugin };
